import type {
  TenantOrganizationResponse,
  UpdateTenantOrganizationRequest,
} from "@repo/shared/types";
import { get, patch } from "@/lib/api/_client";

const URL = "/internal/tenant/organization";

export function getTenantOrganization(): Promise<TenantOrganizationResponse> {
  return get<TenantOrganizationResponse>(URL);
}

export function updateTenantOrganization(
  payload: UpdateTenantOrganizationRequest,
): Promise<TenantOrganizationResponse> {
  return patch<TenantOrganizationResponse>(URL, payload satisfies UpdateTenantOrganizationRequest);
}
